import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, InputAdornment, Checkbox, ListItemText, Box, Chip } from '@mui/material';
import { BusinessOutlined } from '@mui/icons-material';
import { useHstAccessEditor } from '../../../../hooks/useHstAccessEditor';
import { useGetHstCentersQuery } from '../../../../../../services/DimensionService/dimensionApi';
import { EditorMode } from '../../../../types/editorTypes';

interface Props {
  mode: EditorMode;
}

export const HstCenterEditor: React.FC<Props> = ({ mode }) => {
  const { request, updateRequest } = useHstAccessEditor(mode);
  const { data: hstCenters = [], isLoading } = useGetHstCentersQuery();
  const selectedCenters = request?.centers || [];
  const labelId = `${mode}-hst-centers-label`;

  const handleChange = (values: string[]) => {
    updateRequest({ centers: values });
  };

  return (
    <FormControl size="small" fullWidth required>
      <InputLabel id={labelId}>HST Centers</InputLabel>
      <Select
        labelId={labelId}
        multiple
        value={selectedCenters}
        onChange={(e) => handleChange(e.target.value as string[])}
        label="HST Centers"
        disabled={isLoading}
        renderValue={(selected) => (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {selected.map((value) => {
              const center = hstCenters.find(c => c.value === value);
              return (
                <Chip key={value} label={center ? `${center.name} (${center.value})` : value}
                  size="small" sx={{ height: '20px', fontSize: '0.75rem' }} />
              );
            })}
          </Box>
        )}
        startAdornment={
          <InputAdornment position="start">
            <BusinessOutlined sx={{ color: '#64748b', fontSize: 18 }} />
          </InputAdornment>
        }
        MenuProps={{ PaperProps: { style: { maxHeight: 224, width: 250 } } }}
      >
        {hstCenters.map((center) => (
          <MenuItem key={center.value} value={center.value}>
            <Checkbox checked={selectedCenters.includes(center.value)} size="small" />
            <ListItemText primary={`${center.name} (${center.value})`}
              primaryTypographyProps={{ fontSize: '0.875rem' }} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default HstCenterEditor;
